export default String.raw`
.reportContent {
    background-color: $bgColor;

    &-form {
        height: fit-content;
        margin: 0 auto 32px;
        border-radius: 5px;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
        background-color: $bgColor;
        width: fit-content;
        max-width: 760px;
        padding: 32px;

        .primary-action-button {
            width: 100%;
        }

        .consentsList {
            margin-bottom: 24px;
        }

        .checkBoxes__container input:checked+label .checkBoxes__checkIcon {
            top: 0.45rem;
        }

        .checkBoxes__container input + label {
            padding: 8px 0 8px 0px;
        }
    }

    &-popup {
        width: 760px;
        margin: 0;
        padding: 0 32px 32px;

        .primary-action-button {
            width: 100%;
        }

        .consentsList {
            margin-bottom: 24px;
        }

        .checkBoxes__container input:checked+label .checkBoxes__checkIcon {
            top: 0.45rem;
        }

        .checkBoxes__container input + label {
            padding: 8px 0 8px 0px;
        }

        .inputs-container-js {
            max-height: 550px;
            overflow: auto;
            padding-right: 24px;
        }
    }

    &-header {
        text-align: center;
        margin-bottom: 24px;
    }

    &-description {
        @include body-1-regular;
        display: block;
        text-align: center !important;
        color: $labelsColor;
        margin-bottom: 24px;

    }
}

.text-overflow {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis
}

.dsa {
    height: 24px;
}
`